import { render, staticRenderFns } from "./translate.vue?vue&type=template&id=72624bfa&scoped=true"
import script from "./translate.vue?vue&type=script&lang=js"
export * from "./translate.vue?vue&type=script&lang=js"
import style0 from "./translate.vue?vue&type=style&index=0&id=72624bfa&prod&scoped=true&lang=css"
import style1 from "./translate.vue?vue&type=style&index=1&id=72624bfa&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72624bfa",
  null
  
)

export default component.exports